import styled from '@emotion/styled';

import { forMobile, Tabs } from '@/design-system';

export const PeriodTabs = styled(Tabs.Root)(({ theme }) => ({
  [forMobile]: {
    marginInline: theme.spacing[16],

    '& > div': {
      display: 'flex',
      width: '100%',
    },

    '& button': {
      flex: '1 0 0',
      justifyContent: 'center',
    },
  },
}));
